// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Built against Untitled UI tokens, per
   assets/handoffs/design_handoff_integrations_widget. Band structure
   (header rule, footer rule) comes from Card/Card.Header defaults; the row
   grid, logo tile and footer have no Untitled equivalent. */

.csw-tertiary-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--text-sm-size);
  font-weight: 600;
  color: var(--color-brand-700);
  text-decoration: none;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
}

.csw-tertiary-link:hover {
  color: var(--color-brand-800);
  text-decoration: none;
}

/* Reused for both "Reconnect" (on a failed row) and the no-source state's
   "Set up integration" — identical treatment in the design. */
.csw-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 10px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  box-shadow: var(--shadow-xs);
  font-size: var(--text-xs-size);
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}

.csw-btn-secondary:hover {
  background: var(--bg-secondary);
  text-decoration: none;
}

/* Rows */
.csw-rows {
  padding: 4px 0;
}

.csw-row {
  display: grid;
  grid-template-columns: 32px 1fr auto;
  align-items: center;
  grid-column-gap: 12px;
  column-gap: 12px;
  padding: 14px 24px;
  border-bottom: 1px solid var(--border-secondary);
}

.csw-rows .csw-row:last-child {
  border-bottom: 0;
}

.csw-row:hover {
  background: var(--bg-secondary);
}

.csw-logo {
  width: 32px;
  height: 32px;
  flex: none;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-secondary);
  background: var(--bg-secondary);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.csw-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.csw-who {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.csw-name {
  font-size: var(--text-sm-size);
  line-height: var(--text-sm-line);
  font-weight: 500;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.csw-meta {
  font-size: var(--text-xs-size);
  line-height: 18px;
  color: var(--text-tertiary);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.csw-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: none;
}

/* No source connected — the only state that drops the footer band (see
   README: removing the last integration deletes its sync history, so
   there's nothing for the footer to report). */
.csw-empty {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 24px;
}

.csw-empty-copy {
  margin: 0;
  font-size: var(--text-sm-size);
  line-height: var(--text-sm-line);
  color: var(--text-tertiary);
  max-width: 46ch;
  text-wrap: pretty;
}

.csw-footer {
  padding: 12px 24px;
  border-top: 1px solid var(--border-secondary);
  font-size: var(--text-xs-size);
  line-height: 18px;
  color: var(--text-tertiary);
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}
`, "",{"version":3,"sources":["webpack://./src/apps/admin/pages/DashboardPage/CalendarSourcesWidget/CalendarSourcesWidget.css"],"names":[],"mappings":"AAAA;;;4DAG4D;;AAE5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;8DAC8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,uCAAuC;EACvC,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,qBAAgB;EAAhB,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,6BAAkC;EAAlC,kCAAkC;AACpC","sourcesContent":["/* Built against Untitled UI tokens, per\n   assets/handoffs/design_handoff_integrations_widget. Band structure\n   (header rule, footer rule) comes from Card/Card.Header defaults; the row\n   grid, logo tile and footer have no Untitled equivalent. */\n\n.csw-tertiary-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--text-sm-size);\n  font-weight: 600;\n  color: var(--color-brand-700);\n  text-decoration: none;\n  background: none;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n}\n\n.csw-tertiary-link:hover {\n  color: var(--color-brand-800);\n  text-decoration: none;\n}\n\n/* Reused for both \"Reconnect\" (on a failed row) and the no-source state's\n   \"Set up integration\" — identical treatment in the design. */\n.csw-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 10px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-primary);\n  background: var(--bg-primary);\n  box-shadow: var(--shadow-xs);\n  font-size: var(--text-xs-size);\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.csw-btn-secondary:hover {\n  background: var(--bg-secondary);\n  text-decoration: none;\n}\n\n/* Rows */\n.csw-rows {\n  padding: 4px 0;\n}\n\n.csw-row {\n  display: grid;\n  grid-template-columns: 32px 1fr auto;\n  align-items: center;\n  column-gap: 12px;\n  padding: 14px 24px;\n  border-bottom: 1px solid var(--border-secondary);\n}\n\n.csw-rows .csw-row:last-child {\n  border-bottom: 0;\n}\n\n.csw-row:hover {\n  background: var(--bg-secondary);\n}\n\n.csw-logo {\n  width: 32px;\n  height: 32px;\n  flex: none;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-secondary);\n  background: var(--bg-secondary);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.csw-logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.csw-who {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.csw-name {\n  font-size: var(--text-sm-size);\n  line-height: var(--text-sm-line);\n  font-weight: 500;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.csw-meta {\n  font-size: var(--text-xs-size);\n  line-height: 18px;\n  color: var(--text-tertiary);\n  font-variant-numeric: tabular-nums;\n}\n\n.csw-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: none;\n}\n\n/* No source connected — the only state that drops the footer band (see\n   README: removing the last integration deletes its sync history, so\n   there's nothing for the footer to report). */\n.csw-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 20px 24px;\n}\n\n.csw-empty-copy {\n  margin: 0;\n  font-size: var(--text-sm-size);\n  line-height: var(--text-sm-line);\n  color: var(--text-tertiary);\n  max-width: 46ch;\n  text-wrap: pretty;\n}\n\n.csw-footer {\n  padding: 12px 24px;\n  border-top: 1px solid var(--border-secondary);\n  font-size: var(--text-xs-size);\n  line-height: 18px;\n  color: var(--text-tertiary);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  font-variant-numeric: tabular-nums;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
